// import HeroImg from "../../../assets/images/banner.svg";
import HeroAnime from "../../../assets/videos/heroVid.mp4";
import styles from "./Hero.module.css";
// import Button from "../../../components/Button";
// import BckRing from "../../../assets/images/herounderlay.png";
import ButtonArr from "../../../components/Button/ButtonArr";
import CircleIcon from "@mui/icons-material/Circle";
import { useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import { openSignupWithMarketingParams } from "../../../utils/signupMarketingUrl";
// import Info from "../../../assets/images/hero.gif";

const Hero = () => {
  const handleSignupClick = () => {
    openSignupWithMarketingParams();
  };
  useEffect(() => {
    // For Loading Calendly CSS
    const link = document.createElement("link");
    link.href = "https://assets.calendly.com/assets/external/widget.css";
    link.rel = "stylesheet";
    document.head.appendChild(link);

    // For Loading Calendly script
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  const handleClick = (e) => {
    e.preventDefault();
    if (window.Calendly && typeof window.Calendly.initPopupWidget === "function") {
      window.Calendly.initPopupWidget({
        url: process.env.REACT_APP_CALENDLY_URL
      });
    } else {
      // eslint-disable-next-line no-alert
      toast.info("Calendly widget is still loading. Please try again shortly.");
    }
  };

  return (
    <div className={`${styles.herocontainer}`}>
      <div className={`${styles.background}`}></div>
      <div className={`${styles.container}`}>
        <div className={`${styles.contmargin} flex space-between`}>
          <div className={`${styles.heroflexleft}`}>
            <div
              className={`${styles.herofirst} flex gap-24 align-item-center`}
            >
              <CircleIcon className="light-blue" />
              <p>We are building the future of school management</p>
            </div>
            <h1 className={`${styles.lgscreen}`}>Shelf21 - The complete school management system.</h1>
            <h1 className={`${styles.smscreen}`}>Streamline Your School Management with Shelf21.</h1>
            <h6>
              Empowering Schools, Engaging Students, and Connecting Parents, all
              in one platform.
            </h6>
            <div className={`${styles.btn_div} flex gap-16 flex-wrap`}>
              <div className={styles.get_btn}>
                <ButtonArr title="Get Started" onClick={handleSignupClick} />
              </div>
              <div className={styles.bookbtn}>
                <a href="#" onClick={handleClick}>
                  Book a Demo
                </a>
              </div>

              {/* <Button title="Book a Demo" /> */}
            </div>
          </div>
          <div className={styles.videowrapper}>
            <video className={`${styles.heroimage}`} loop autoPlay muted>
              <source src={HeroAnime} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
          </div>
          {/* <img src={HeroAnime} alt="" className={`${styles.heroimage}`} max-width="100%" /> */}
        </div>
        {/* <img src={BckRing} alt="" className={`${styles.ringone}`} />
        <img src={BckRing} alt="" className={`${styles.ringtwo}`} /> */}
      </div>
      <ToastContainer />
    </div>
  );
};

export default Hero;
